<div class="row col-md-12" *ngIf="configuracion != undefined">
    <div class="row {{configuracion.tamanoTitulo}} left-15 mr-3 content-header">
        {{configuracion.titulo}}
        <small class="ml-2 text-muted" *ngIf="configuracion.maxImagenes">
            (máximo {{configuracion.maxImagenes}} imágenes)
        </small>
    </div>
    <div class="row {{configuracion.tamanoBoton}} mb-1" *ngIf="!configuracion.consultar">
        <div>
            <i (click)="clicBotonAdicionarImagen()" title="Adicionar imagen"
                class="btn btn-outline-info left-15 mt-2 mb-0 mr-1 fa fa-plus-square"
                [class.disabled]="!puedeAdicionar">
            </i>
            <i (click)="eliminarImagen()" title="Eliminar imagen seleccionada"
                class="btn btn-outline-info left-15 mt-2 mb-0 mr-1 fa fa-trash">
            </i>
        </div>
    </div>

    <input type="file" style="display:none;" accept=".jpg, .jpeg, .png" #inputArchivo
        (change)="cambioArchivo($event.target.files)">

    <div class="col-md-12 pl-1 pr-1" *ngIf="rutasImagenes?.length > 0">
        <ngu-carousel #carousel [inputs]="configsCarrusel" [dataSource]="rutasImagenes"
            class="col-md-12 pl-1 pr-1">
            <ngu-item NguCarouselItem class="bannerStyle" *nguCarouselDef="let item;"
                [class.bordeTarjetaSeleccionado]="item === imagenSeleccionadaActual">
                <div class="m-1 card no-border box-shadow-0" (click)="imagenSeleccionada(item)">
                    <div class="card-body">
                        <img alt="Imagen adjunta" class="card-img img-fluid" [src]="item.visible">
                    </div>
                </div>
            </ngu-item>

            <button [hidden]="false" NguCarouselPrev
                class='btn btn-outline-primary btn-round .btn-sm leftRs'>&lt;</button>
            <button [hidden]="false" NguCarouselNext
                class='btn btn-outline-primary btn-round .btn-sm rightRs'>&gt;</button>
        </ngu-carousel>
    </div>
</div>
